module.exports = __webpack_public_path__ + "assets/images/animations/medipremium-animation.png?5833f899";